<template>
  <div class="upgrade-pkgs-popup">
    <upPopup :show="value" @close="$emit('input', false)" :showCloseBtn="false">
      <div class="title">
        精选方案<span>（{{ items.length }}）</span>
      </div>
      <div class="pkgs-wrap">
        <updgradePkg
          class="upgrade-pkg"
          @toOrder="toOrder"
          @showDetail="id => $emit('showDetail', id)"
          v-for="item in items"
          :key="item.id"
          :item="item"
        />
      </div>
      <div class="bottom-mask"></div>
    </upPopup>
  </div>
</template>

<script>
import upPopup from '../common/upPopup.vue'
import updgradePkg from './upgradePkg.vue'

export default {
  components: {
    upPopup,
    updgradePkg
  },
  props: {
    value: Boolean,
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    bgImg() {
      return require('images/platform/homepage/coupon-bg.png')
    },
    isLogin() {
      return this.$store.getters.isLogin
    }
  },
  methods: {
    toOrder(pkg) {
      this.$trackEvent('newprofilepages_plan', {
        package_id: pkg.id
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upgrade-pkgs-popup {
  /deep/ .common-model-up-close-btn {
    display: none;
  }
  /deep/ .hp-up-popup-rule-model {
    padding-top: 0;
    padding-left: 0;
  }
  .title {
    position: absolute;
    margin-top: 10px;
    width: 10rem;
    border-radius: 30px 30px 0 0;
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 700;
    color: #21252d;
    line-height: 36px;
    text-align: center;
    padding: 41px 0 35px;
    background: #fff;
    z-index: 9;
    margin: 0;
    span {
      font-size: 24px;
    }
  }
  .pkgs-wrap {
    padding-left: 20px;
    margin-top: 130px;
    .upgrade-pkg {
      width: 100% !important;
      margin-top: 30px;
      &:last-of-type {
        margin-bottom: 136px;
      }
    }
  }
  .bottom-mask {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 750px;
    height: 165px;
    background: #ffffff;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 1)
    );
  }
}
</style>
